module.exports = __webpack_public_path__ + "static/media/bookingsActive.d97baec1.svg";